import { Table } from "react-bootstrap";
import type { LotAdjustmentRow } from "../lib/explainTypes";
import { labelFor } from "./ConstrainOverview";
import { formatCurrency } from "../../../lib/numbers";

interface Props {
  lots: LotAdjustmentRow[];
  isTaxable: boolean;
}

const dash = "—";

// Lot expansion content shown when a symbol row in
// SymbolConstraintTable is expanded. Columns per
// dc-constrain-section-ui-redesign-replace-019e1dc7 §1:
//   Lot  Acq  Shrs  Cost  Gain  T  Priority  Capped by
//
// The current explain payload only carries shares / realized_gain /
// priority / stop_reason on each lot — Acq / Cost / Term aren't
// emitted yet. Those columns render `—` until the python side adds
// them. On IRA accounts the contract also says Priority and Capped
// by are `—` (no lot walker engaged).
export default function LotDetailRows({ lots, isTaxable }: Props) {
  if (lots.length === 0) {
    return <div className="text-muted small">No lot detail.</div>;
  }
  return (
    <Table size="sm" className="mb-0 small" aria-label="Lot detail">
      <thead className="text-muted">
        <tr>
          <th>Lot</th>
          <th>Acq</th>
          <th className="text-end">Shrs</th>
          <th className="text-end">Cost</th>
          <th className="text-end">Gain</th>
          <th>T</th>
          <th className="text-end">Priority</th>
          <th>Capped by</th>
        </tr>
      </thead>
      <tbody>
        {lots.map((lot, i) => {
          const gain = Number(lot.realized_gain ?? 0);
          const cappedBy = lot.stop_reason
            ? labelFor(lot.stop_reason)
            : lot.limiting_factor
              ? labelFor(lot.limiting_factor)
              : dash;
          const priorityDisplay =
            !isTaxable || lot.priority == null
              ? dash
              : Number(lot.priority).toFixed(4);
          return (
            <tr key={`${lot.symbol}-${i}`}>
              <td>#{i + 1}</td>
              <td className="text-muted">{dash}</td>
              <td className="text-end">{lot.shares}</td>
              <td className="text-end text-muted">{dash}</td>
              <td className="text-end">{formatCurrency(gain)}</td>
              <td className="text-muted">{dash}</td>
              <td className="text-end">{priorityDisplay}</td>
              <td>{cappedBy}</td>
            </tr>
          );
        })}
      </tbody>
    </Table>
  );
}
